export const errorHandler = (error, defaultMsg) => {
    const { request, response } = error
    if (response) {
      const { message } = response.data
      const status = response.status
      
      return {
        message: message || defaultMsg,
        status,
      }
    } else if (request) {
      //request sent but no response received
      return {
        message: 'server time out',
        status: 503,
      }
    } else {
      // Something happened in setting up the request that triggered an Error
      return { message: defaultMsg }
    }
  }
  